import { render, staticRenderFns } from "./ProjectMember.vue?vue&type=template&id=a4d3e464&"
import script from "./ProjectMember.vue?vue&type=script&lang=js&"
export * from "./ProjectMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports